// /src/components/TopBar.js
import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton
} from "@mui/material";
import { Brightness4, Brightness7 } from "@mui/icons-material";

export default function TopBar({ serial, location, mode, toggleTheme }) {
  return (
    <AppBar position="static">
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 500, flexGrow: 1, textAlign: "center" }}
        >
          {serial && location ? `${serial} (${location})` : "Vending Machine"}
        </Typography>
        <IconButton sx={{ ml: 2 }} onClick={toggleTheme} color="inherit">
          {mode === "dark" ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
